import * as _ from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IArrayResponse, IObjectResponse } from '@nkr/store/index';
import { IBaseResponse } from '@nkr/models/index';
import { ActionsAdminLineItems, IManualInvoiceLineItem, IManualInvoiceLineItemLookup } from '@nkr/store/billing/actions-admin-line-items';
import { FilterWrapper } from '../transplant-invoices/styles';
import ManualLineItemAddFormRow from './line-item-add';
import { GridApi, ColumnApi, GridReadyEvent, CsvExportParams, ProcessCellForExportParams } from 'ag-grid-community';
import { Row, Button, FormControl, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import Grid from './grid';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps { }

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<IObjectResponse<IManualInvoiceLineItemLookup>>,
    getLineItems: (invoiceDate: string, organType?: OrganType) => Promise<IArrayResponse<IManualInvoiceLineItem>>,
    removeLineItem: (id: number) => Promise<IBaseResponse>,
    addLineItem: (lineItem: IManualInvoiceLineItem) => Promise<IBaseResponse>
}

interface IState {
    invoiceDate: string,
    lineItems: IManualInvoiceLineItem[],
    lookup: IManualInvoiceLineItemLookup,
    gridApi: GridApi,
    columnApi: ColumnApi,
    total: number,
    centerId: number,
    userId: number,
    organTypes: OrganType[]
}

type TProps = IProps & IStateProps & IDispatchProps;

class ManualLineItemsIndex extends React.Component<TProps, IState> {
    readonly state: IState = {
        invoiceDate: moment().endOf('month').format("YYYY-MM-DD"),
        lineItems: [],
        lookup: null,
        gridApi: null,
        columnApi: null,
        total: 0,
        centerId: 0,
        userId: 0,
        organTypes: [OrganType.Kidney, OrganType.Liver]
    }

    componentDidMount = () => {
        this.getData();
    }

    onGridReady = (event: GridReadyEvent) => {
        this.setState({
            gridApi: event.api,
            columnApi: event.columnApi
        });
    }

    getData = () => {
        let { organTypes } = this.state;
        let organType = organTypes.length == 2 ? null : organTypes[0];
        this.props.showLoading('Getting line-items, one moment please...')
            .then(() => Promise.all([
                this.props.getLineItems(this.state.invoiceDate, organType),
                this.props.getLookupData()
            ]))
            .then(([lineItemsResponse, lookupDataResponse]) => {
                if (lineItemsResponse.data.success && lookupDataResponse.data.success) {

                    this.setState({
                        lineItems: lineItemsResponse.data.results,
                        lookup: lookupDataResponse.data.result,
                        // organTypes: organType ? [organType] : [OrganType.Kidney, OrganType.Liver]
                    });
                }
            })
            .finally(() => this.props.hideLoading())
            ;
    }

    refreshData = () => {
        let { organTypes } = this.state;
        let organType = organTypes.length == 2 ? null : organTypes[0];

        this.props.showLoading('Getting line-items, one moment please...')
            .then(() => this.props.getLineItems(this.state.invoiceDate, organType))
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        lineItems: response.data.results
                    });
                }
            })
            .finally(() => { this.props.hideLoading(); })
            ;
    }

    formatMoney = (value: any) => {
        let num = Number(value);
        return isNaN(num) ? "$-.--" : `\$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    prevMonth = () => {
        let newMonth = moment(this.state.invoiceDate).subtract(1, 'month');
        this.setState({ invoiceDate: newMonth.format("YYYY-MM-DD") }, () => this.refreshData())
    }

    nextMonth = () => {
        let newMonth = moment(this.state.invoiceDate).add(1, 'month');
        this.setState({ invoiceDate: newMonth.format("YYYY-MM-DD") }, () => this.refreshData())
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleUserChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            userId: parseInt(e.currentTarget.value)
        });
    }

    deleteLineItem = (id: number) => {
        this.props.showLoading('Updating Line Items...')
            .then(() => this.props.removeLineItem(id))
            .then(() => this.props.hideLoading())
            .then(() => this.refreshData())
            ;
    }

    addLineItem = (item: IManualInvoiceLineItem) => {
        this.props.showLoading('Updating Line Items...')
            .then(() => this.props.addLineItem(item))
            .then(() => this.props.hideLoading())
            .then(() => this.refreshData())
            ;
    }


    changeOrganType = (values: OrganType | OrganType[]) => {
        let safeValues = Array.isArray(values) ? values : [values];
        if (safeValues.length == 0) return;
        this.setState({ organTypes: safeValues }, () => this.getData());
    }

    handleExport = () => {
        let fileName = 'InvoicesLineItems_' + this.state.invoiceDate + '.csv';
        let columnKeys = this.state.columnApi.getAllColumns().filter(x => x.getColId() != 'actions').map(x => x.getColId());

        let params: CsvExportParams = {
            columnGroups: true,
            allColumns: true,
            fileName: fileName,
            columnKeys,
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.field == 'organType')
                    return params.value == 0 ? 'Kidney' : params.value == 1 ? 'Liver' : params.value;

                if (params.node.rowPinned == 'top') {
                    if (colDef.colId == 'isCredit')
                        return '';
                }
                if (colDef.colId == 'isCredit')
                    return params.value ? "Credit" : "Debit";
                if (colDef.colId == 'actions')
                    return "";

                var result = params.value;
                return result;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    getFilteredList = () => {
        let list = this.state.lineItems;

        if (this.state.centerId > 0) {
            list = list.filter(x => x.centerId == this.state.centerId)
        }

        if (this.state.userId > 0) {
            list = list.filter(x => x.userId == this.state.userId)
        }

        return list;
    }

    render = () => {
        var centerList = _.sortBy(_.uniqBy(this.state.lineItems.map(x => ({ id: x.centerId, alias: x.centerAlias })), item => item.id), item => item.alias);
        var userList = _.sortBy(_.uniqBy(this.state.lineItems.map(x => ({ id: x.userId, alias: x.username })), item => item.id), item => item.alias);
        var date = moment(this.state.invoiceDate).format("MMMM, YYYY");
        var total = this.state.total;
        var filteredList = this.getFilteredList();
        var organValue = this.state.organTypes.length == 2 ? -1 : this.state.organTypes[0];

        return (
            <>
                <FilterWrapper>
                    <div className="row">
                        <div className="col-xs-12 col-sm-9 col-md-6">
                            <div className="row">
                                <div className="col-xs-3">
                                    <button className='btn btn-primary btn-block' onClick={this.prevMonth.bind(this)}>&laquo; prev</button>
                                </div>
                                <div className="col-xs-6"><h4 style={{ textAlign: "center", margin: "0 0 0 0", lineHeight: "1.75em" }}>Line Items for {date}</h4></div>
                                <div className="col-xs-3">
                                    <button className='btn btn-primary btn-block' onClick={this.nextMonth.bind(this)}>next &raquo;</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </FilterWrapper>
                <Row>
                    <div className="col-xs-12" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 15 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <h4 style={{ margin: "0 10px 0 0", lineHeight: "1.75em", whiteSpace: 'nowrap' }}>&nbsp;Organ:</h4>
                            <ToggleButtonGroup type='radio' name='organs' value={organValue}>
                                <ToggleButton value={-1} onChange={() => this.changeOrganType([OrganType.Kidney, OrganType.Liver])}
                                    className={this.state.organTypes.length == 2 ? 'btn-primary btn-md' : 'btn-md'}>All</ToggleButton>
                                <ToggleButton value={OrganType.Kidney} onChange={() => this.changeOrganType(OrganType.Kidney)}
                                    className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Kidney) ? 'btn-primary btn-md' : 'btn-md'}>Kidney</ToggleButton>
                                <ToggleButton value={OrganType.Liver} onChange={() => this.changeOrganType(OrganType.Liver)}
                                    className={this.state.organTypes.length == 1 && this.state.organTypes.includes(OrganType.Liver) ? 'btn-primary btn-md' : 'btn-md'}>Liver</ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: 40 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 20, fontSize: 14 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                    <span style={{ whiteSpace: 'nowrap' }}>Added by:</span>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.userId}
                                        onChange={this.handleUserChange}
                                    >
                                        <option value={0}>- All Users -</option>
                                        {userList.map(user =>
                                            <option key={`ctr-${user.id}`} value={user.id}>{user.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                    <span>Center:</span>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.centerId}
                                        onChange={this.handleCenterChange}
                                    >
                                        <option value={0}>- All Centers -</option>
                                        {centerList.map(center =>
                                            <option key={`ctr-${center.id}`} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            </div>
                            <Button bsStyle='success' onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>
                </Row>
                <Grid
                    list={filteredList}
                    onGridReady={this.onGridReady}
                    deleteLineItem={this.deleteLineItem}
                />

                <div className='row' style={{ marginTop: "20px", overflow: "visible" }}>
                    <div className='col-xs-12'>
                        <table className='table table-striped'>
                            {this.state.lookup != null &&
                                <ManualLineItemAddFormRow invoiceDate={this.state.invoiceDate} lookup={this.state.lookup} addLineItem={this.addLineItem.bind(this)} />
                            }
                        </table>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getLookupData: () => { return dispatch(ActionsAdminLineItems.getLookupData()); },
        getLineItems: (invoiceDate: string, organType?: OrganType) => { return dispatch(ActionsAdminLineItems.getLineItems(invoiceDate, organType)); },
        addLineItem: (lineItem: IManualInvoiceLineItem) => { return dispatch(ActionsAdminLineItems.addLineItem(lineItem)); },
        removeLineItem: (id: number) => { return dispatch(ActionsAdminLineItems.removeLineItem(id)) }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(ManualLineItemsIndex);